/**
 * Page initialization functionality for MDMS - ES6 Module Version
 * Converted from the original public/js/page.js for webpack compatibility
 */

// Maintain backward compatibility with global namespace
if (typeof window.mdms === 'undefined') {
    window.mdms = {};
}

const pageHelpers = {
    /**
     * Initialize page-specific functionality
     */
    init() {
        this.setupEventHandlers();
        this.adjustPageContentMargin();
        this.initializeDatetimePickers();
        this.setupDynamicContent();
        this.bootstrapSite();
        this.stripFormClasses();
    },

    /**
     * Setup event handlers for page interactions
     */
    setupEventHandlers() {
        jQuery(function ($) {
            // Adjust if window is resized (useful for responsive design)
            $(window).resize(function() {
                pageHelpers.adjustPageContentMargin();
            });
        });
    },

    /**
     * Adjust page content margin based on navbar height
     */
    adjustPageContentMargin() {
        const navbarHeight = $("#top-nav").outerHeight();
        $(".page-content").css('margin-top', navbarHeight + 'px');
    },

    /**
     * Initialize datetime pickers
     */
    initializeDatetimePickers() {
        jQuery(function ($) {
            $('input[type="datetime"]').each(function(){
                $(this).datetimepicker();
            });
        });
    },

    /**
     * Strip form classes for form reset functionality
     * @param {jQuery} $element - Element to strip classes from
     */
    stripFormClasses(elem) {
        $(".remove-cols").each(function(){
            $(this).children().each(function(){
            $(this).removeClass("col-sm-3").removeClass("col-sm-9");
            });
        });
        
        elem.find(".form-field-row").each(function(){
            if(!$(this).parent().parent().hasClass('row')){
                $(this).parent().removeClass(function(index, className) {
                    return (className.match(/\bcol-\S+/g) || []).join(' ');
                });
                $(this).parent().prev().removeClass(function(index, className) {
                    return (className.match(/\bcol-\S+/g) || []).join(' ');
                });
            }
        });
    },

    /**
     * Setup dynamic content handling
     */
    setupDynamicContent() {
        const cache = {};

        jQuery("#dynamic-content-tracker").on('change', function(){
            const elemId = jQuery(this).val();

            // Handle dynamic content reset
            jQuery("body").one('mouseenter', ".js-reset", function(){
                const $this = jQuery(this);

                // Strip form classes and reinitialize
                pageHelpers.stripFormClasses($this);
                mdms.form.register_validators($this.find("form"));

                // Reinitialize autocomplete
                $this.find(".autocomplete").each(function(){
                    mdms.form.autocomplete.register(jQuery(this), cache);
                });

                // Reinitialize form fields
                $this.find(".toggle-visibility").each(function(){
                    mdms.form.toggle_visibility(jQuery(this));
                });

                // Reinitialize datetime pickers
                $this.find('input[type="datetime"]').each(function(){
                    jQuery(this).datetimepicker();
                });
            });
        });
    },

    bootstrapSite() {
        const boot = window.mdms.boot;
        if (!boot || !boot.site) return;

        const site = boot.site || {};
        const assetsPath = "/public/sites/"+site.path+"/";

        /* Helpers */
        function setText(selector, value) {
            document.querySelectorAll(selector).forEach(el => {
                el.textContent = value;
            });
        }

        function setAttr(selector, attr, value) {
            document.querySelectorAll(selector).forEach(el => {
                el.setAttribute(attr, value);
            });
        }

        function t(key, vars = {}) {
            let str = dict[key];
            if (!str) return key;

            Object.entries(vars).forEach(([k, v]) => {
                str = str.replaceAll(`{{${k}}}`, v);
            });

            return str;
        }

        function setTheme(site) {
            document.documentElement.style.setProperty('--primary', site.primary_color);
            document.documentElement.style.setProperty('--secondary', site.secondary_color);
            document.documentElement.style.setProperty('--dark-primary', site.dark_primary_color);
            document.documentElement.style.setProperty('--light-primary', site.light_primary_color);
        }

        /* Title */
        if (site.name) {
            document.title = site.name;
            setText('[data-site-name]', site.name);
        }

        /* Favicon */
        if (site.favicon) {
            let link =
            document.querySelector('link[rel="icon"]') ||
            document.querySelector('link[data-favicon]');

            if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
            }

            link.href = assetsPath+site.favicon;
        }

        /* Logo */
        if (site.logo) {
            setAttr('[data-site-logo]', 'src', assetsPath+site.logo);
        }
        
        /* Splash */
        if (site.splash) {
            setAttr('[data-splash]', 'src', assetsPath+site.splash);
        }

        /* ---------- i18n text ---------- */
        document.querySelectorAll('[data-i18n]').forEach(el => {
            const key = el.dataset.i18n;
            el.textContent = t(key, { site: site.name });
        });

        setTheme(site);
    }
};

// ES6 module exports - maintain backward compatibility
window.mdms.pageHelpers = pageHelpers;
export { pageHelpers as page };
export default pageHelpers;
